import { createContext, useContext, useState } from "react";

const SystemModeContext = createContext();

export const SystemModeProvider = ({ children }) => {
  const [isOverdrive, setIsOverdrive] = useState(false);
  const [isDebug, setIsDebug] = useState(false);

  return (
    <SystemModeContext.Provider
      value={{ isOverdrive, setIsOverdrive, isDebug, setIsDebug }}
    >
      {children}
    </SystemModeContext.Provider>
  );
};

export const useSystemMode = () => useContext(SystemModeContext);